import React from 'react';
import { MDBFooter } from 'mdb-react-ui-kit';

const AdminFooter = React.memo((props) =>{
  return (
    <MDBFooter className='text-center text-lg-left'>
      <div className='text-center p-3'>
        &copy; {new Date().getFullYear()} Copyright:{' '}
        United Order
      </div>
    </MDBFooter>
  );
});

export default AdminFooter;